import React from "react";
import cns from "classnames";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography
} from "@material-ui/core";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  actions?: React.ReactNodeArray;
  centered?: boolean;
  message?: string;
  title: string;
  style?: React.CSSProperties;
  elevation?: number;
  variant?: "outlined" | "elevation";
  fullWidth?: boolean;
};

export function ErrorCard(props: Props) {
  const { actions, centered, message, title } = props;
  const classes = useStyles({});

  const className = cns({
    [classes.limitedWidth]: !props.fullWidth,
    [classes.centered]: centered
  });

  return (
    <Card
      className={className}
      style={props.style}
      elevation={props.elevation}
      variant={props.variant}
    >
      <CardHeader className={classes.header} title={title}/>
      {message && (
        <CardContent>
          <Typography variant="body2">
            <code>{message}</code>
          </Typography>
        </CardContent>
      )}
      {actions && actions.length > 0 && <CardActions>{actions}</CardActions>}
    </Card>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  limitedWidth: {
    maxWidth: theme.spacing(40)
  },

  header: {
    "& > * > *": {
      color: theme.palette.error.main
    }
  },

  centered: {
    marginLeft: "auto",
    marginRight: "auto"
  }
}));
